import type { User } from '@chatapp-inbox/shared';
import type { ApiError } from '../api';

/** Chave da query da sessão. Os dados são `SessionResponse | null` (null = ninguém conectado). */
export const SESSION_KEY = ['session'] as const;

export type SessionState =
  | { status: 'loading' }
  | { status: 'authenticated'; user: User }
  /** `expired`: a sessão acabou no meio do uso (401 numa rota protegida), não é um "ainda não entrei". */
  | { status: 'unauthenticated'; expired: boolean }
  /** Não foi possível nem perguntar quem é o usuário (rede fora do ar, 5xx). */
  | { status: 'error'; error: ApiError; retry: () => void };
